module.exports = __webpack_public_path__ + "static/img/discount.43cde10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discount.png
// module id = bubI
// module chunks = 1